import liff from '@line/liff/dist/lib';
import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import api from '../../api';
import Bottom from './Bottom';

@inject('commonStore', 'menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class PaymentSoftBank extends Component {
  formRef = React.createRef();

  componentDidMount() {
    const { orderStore } = this.props;

    // 결제 방법 기본값을 카드로 설정
    if (!orderStore.paymentMethod) {
      orderStore.setPaymentMethod(this.getCreditPaymentMethod());
    }
  }

  getCreditPaymentMethod = () => {
    const { commonStore } = this.props;
    return commonStore.companyId.toLowerCase() === 'momstouchjp' && commonStore.storeCode === '1001'
      ? 'credit'
      : 'credit3d2';
  };

  // 결제방법 변경
  handlePayMethodChange = event => {
    this.props.orderStore.setPaymentMethod(event.target.value);
  };

  pay = async () => {
    const { commonStore, menuStore, cartStore, userStore, orderStore } = this.props;

    if (liff.isInClient()) {
      const lineProfile = await liff.getProfile();
      userStore.userData.phoneNumber = lineProfile.userId;
    } else {
      userStore.userData.phoneNumber = null;
    }

    // 주문 저장
    const response = await api.addOrder(orderStore.orderData);

    //--------------------- 해시코드 생성 시 모든 결제 데이터를 사용하기 때문에 결제 데이터 추가/변경 시 서버도 같이 변경이 필요함 ----------------------------//
    orderStore.setPaymentSBData({
      pay_method: orderStore.paymentMethod,
      merchant_id: menuStore.storeData.merchantID,
      service_id: menuStore.storeData.extraKey,
      cust_code: userStore.userData.phoneNumber
        ? userStore.userData.phoneNumber
        : `${menuStore.storeData.merchantID}_${menuStore.storeData.extraKey}_${response.data.orderId}`,
      order_id: response.data.orderId,
      item_id: cartStore.cartData.menus[0].itemCode,
      amount: orderStore.paymentAmount,
      pay_type: '0',
      service_type: '0',
      success_url: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/softbank/success?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&code=${orderStore.orderData.deliveryCode}`,
      cancel_url: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/softbank/cancel?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&code=${orderStore.orderData.deliveryCode}`,
      error_url: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/softbank/error?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}&code=${orderStore.orderData.deliveryCode}`,
      pagecon_url: `${process.env.REACT_APP_SMARTORDER_API_URL}/sales/softbank?companyId=${commonStore.companyId}&storeCode=${commonStore.storeCode}`,
      free1: `${commonStore.companyId}|${commonStore.storeCode}`,
      free2: '',
      request_date: response.data.ediDate + response.data.ediTime,
      hashCode: response.data.signData,
    });

    this.formRef.submit();
  };

  render() {
    const { t, menuStore, orderStore } = this.props;
    return (
      <React.Fragment>
        <div>
          {/* 결제방법 선택 */}
          <Grid item container direction={'column'} spacing={1} style={{ marginTop: '25px' }}>
            <Grid item>
              <span style={{ fontSize: '13pt', fontWeight: 'bold' }}>{t('payment.label.method')}</span>
            </Grid>
            <Grid item>
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={orderStore.paymentMethod}
                onChange={this.handlePayMethodChange}
              >
                {(menuStore.storeData.paymentMethod & 1) === 1 && (
                  <FormControlLabel
                    value={this.getCreditPaymentMethod()}
                    control={<Radio color="primary" />}
                    label={t('payment.button.creditCard')}
                  />
                )}
                {(menuStore.storeData.paymentMethod & 2) === 2 && (
                  <FormControlLabel value="paypay" control={<Radio color="primary" />} label={'PAYPAY'} />
                )}
                {(menuStore.storeData.paymentMethod & 4) === 4 && (
                  <FormControlLabel value="auone" control={<Radio color="primary" />} label={'au PAY'} />
                )}
              </RadioGroup>
            </Grid>
          </Grid>
        </div>
        {orderStore.paymentSBData && (
          <form
            ref={ref => (this.formRef = ref)}
            name="payForm"
            method="post"
            action={`${process.env.REACT_APP_SOFTBANK_URL}/f01/FepBuyInfoReceive.do`}
            acceptCharset="Shift-JIS"
          >
            {/* (옵션) 결제방법 (콤마 구분자로 복수 지정 가능. 생략하는 경우 결제 방법 선택 화면) */}
            <input type="hidden" name="pay_method" value={orderStore.paymentSBData.pay_method} />
            {/* (필수) 상점ID */}
            <input type="hidden" name="merchant_id" value={orderStore.paymentSBData.merchant_id} />
            {/* (필수) 서비스ID */}
            <input type="hidden" name="service_id" value={orderStore.paymentSBData.service_id} />
            {/* (필수) 고객ID */}
            <input type="hidden" name="cust_code" value={orderStore.paymentSBData.cust_code} />
            {/* (필수) 주문ID */}
            <input type="hidden" name="order_id" value={orderStore.paymentSBData.order_id} />
            {/* (필수) 상품ID */}
            <input type="hidden" name="item_id" value={orderStore.paymentSBData.item_id} />
            {/* (옵션) 상품명 */}
            <input type="hidden" name="item_name" value={orderStore.paymentSBData.item_name} />
            {/* (옵션) 세금 */}
            {/* <input type="hidden" name="tax" value={orderStore.pay_method} /> */}
            {/* (필수) 구매 금액 (세금포함) */}
            <input type="hidden" name="amount" value={orderStore.paymentSBData.amount} />
            {/* (필수) 구입타입 */}
            <input type="hidden" name="pay_type" value={orderStore.paymentSBData.pay_type} />
            {/* (필수) 서비스타입 */}
            <input type="hidden" name="service_type" value={orderStore.paymentSBData.service_type} />
            {/* (필수) 결제완료 URL */}
            <input type="hidden" name="success_url" value={orderStore.paymentSBData.success_url} />
            {/* (필수) 결제취소 URL */}
            <input type="hidden" name="cancel_url" value={orderStore.paymentSBData.cancel_url} />
            {/* (필수) 결제오류 URL */}
            <input type="hidden" name="error_url" value={orderStore.paymentSBData.error_url} />
            {/* (필수) 등록통지처CGI. SSL필수 (결제성공 시 결제완료 처리할 URL?) */}
            <input type="hidden" name="pagecon_url" value={orderStore.paymentSBData.pagecon_url} />
            <input type="hidden" name="free1" value={orderStore.paymentSBData.free1} />
            <input type="hidden" name="free2" value={orderStore.paymentSBData.free2} />
            {/* (필수) 요청일시(YYYYMMDDHHMISS) */}
            <input type="hidden" name="request_date" value={orderStore.paymentSBData.request_date} />
            {/* (옵션) 요청허용시간 */}
            {/* <input type="hidden" name="limit_second" value={orderStore.paymentSBData.limit_second} /> */}
            {/* (필수) 체크섬 */}
            <input type="hidden" name="sps_hashcode" value={orderStore.paymentSBData.hashCode} />
          </form>
        )}

        <Bottom pay={this.pay} />
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(PaymentSoftBank));
